"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keycloakClient = exports.keycloakConfig = void 0;
var tslib_1 = require("tslib");
var keycloak_js_1 = (0, tslib_1.__importDefault)(require("keycloak-js"));
var url = process.env.REACT_APP_KEYCLOAK_URL;
var realm = process.env.REACT_APP_KEYCLOAK_REALM;
var clientId = process.env.REACT_APP_KEYCLOAK_CLIENTID;
exports.keycloakConfig = {
    url: url,
    realm: realm,
    clientId: clientId,
};
exports.keycloakClient = (0, keycloak_js_1.default)(exports.keycloakConfig);
